import Cookies from 'js-cookie'

const TokenKey = 'StarPay-GB-Lang'

export function getLang() {
  return Cookies.get(TokenKey)
}

export function setLang(token) {
  return Cookies.set(TokenKey, token)
}
